module.exports = __webpack_public_path__ + "img/windshooter.3143bd41.png";